(() => {
  angular
    .module('gm.common.services')
    .factory('gmCountries', gmCountriesFactory);

  function gmCountriesFactory(
    Countries,
    States
  ) {
    'ngInject';

    let _list = null;

    return {
      getCountries,
      getCountryByKey,
      getKeyByCountry,
      getStatesByCountryCode,
      prepareCountryForMenu,
      prepareStateForMenu
    };

    function getCountries(blocked) {
      return getList(blocked);
    }

    function getCountryByKey(key, blocked) {
      const found = getList(blocked).find(c => c.key === key);
      return found && found.country;
    }

    function getKeyByCountry(country, blocked) {
      const found = getList(blocked).find(c => c.country === country);
      return found && found.key;
    }

    function getList(origBlocked = []) {
      const blocked = origBlocked.map(b => b.toUpperCase()());

      if (!_list) {
        _list = Countries
          .filter(c => !!c.key)
          .map((c) => {
            c.key = c.key.toUpperCase();
            return c;
          });
      }

      return _list.filter(c => blocked.indexOf(c.id) === -1);
    }

    function getStatesByCountryCode(origCountryCode) {
      const countryCode = origCountryCode.toUpperCase();
      return States.map((s) => {
        s.country = s.country.toUpperCase();
        return s;
      }).filter(s => s.country === countryCode);
    }

    function prepareCountryForMenu(country) {
      return {
        id: country.key,
        name: country.country,
        flag: country.key.toLowerCase()
      };
    }

    function prepareStateForMenu(state) {
      return {
        id: state.code,
        name: state.state
      };
    }
  }
})();
